module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/fontawesome-webfont.eot
// module id = ./node_modules/@ps/common-core/dist/fonts/fontawesome-webfont.eot
// module chunks = 1